module.exports = __webpack_public_path__ + "img/support.977f70fd.jpg";